import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import smallbee from "../assets/8f3479b9762001f0370cb94e488635a5a1211592.gif";
import capbee from "../assets/Group 25.png";
import capbee2 from "../assets/6842a7f196a5b2b2149f793f6a3bebf0f3fa9777 (1).gif";
import capbee22 from "../assets/3939e60ff48ab243dd0431a6300e27947bf4065a.gif";

const faqs = [
  {
    question: "What is Plan BEE gamefi?",
    answer: `• You will receive a Que number for every 25 BEE you purchased
• Que number will be assigned in sequence starting from 1
• You will receive 27 USDT (profit 8%) when the latest Que number matches your Exit number
  → Exit number = Que Number × 3 + 1
• For example, if your Que number is 4, your Exit number will be 4 × 3 + 1 = 13
• You may choose to join Plan BEE gamefi with 50 BEE. You will still receive 25 BEE and a new Que number.`,
  },
  {
    question: "What is Plan BEE gamefi Jackpot?",
    answer:
      "Coming soon! Stay tuned for exciting jackpot details in the Plan BEE gamefi.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="row m-0 p-0 ">
<div
  className="col-12 col-md-2 p-0 d-flex flex-column justify-content-between align-items-center"
//   style={{ height: '100vh' }} // or use '100vh' for full screen height
>
  <img src={capbee2} alt="" style={{ width: '100%', marginTop: '20px' }} />

  <img
    src={smallbee}
    alt=""
    width={100}
    height={100}
    style={{ marginBottom: '20px' }}
  />
</div>
        <div className="col-12 col-md-8 faq-container">
      <h2 className="fw-bolder fs-1 text-center mb-3 mt-5 mt-md-1">Bee FAQ</h2>

      {faqs.map((faq, index) => (
        <div
          key={index}
          className={`accordion-item ${activeIndex === index ? "active" : ""}`}
        >
          <div className="accordion-header" onClick={() => toggle(index)}>
            <span>{faq.question}</span>
            <span className="arrow">
              {activeIndex === index ? (
                <IoIosArrowUp className="bg-warning p-1 fs-2 rounded text-black" />
              ) : (
                <IoIosArrowDown className="bg-warning text-black p-1 fs-2 rounded" />
              )}
            </span>
          </div>
          {activeIndex === index && (
            <div className="accordion-content">
              {faq.answer.split("\n").map((line, i) => (
                <p key={i}> {line.trim()}</p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
    <div className="col-12 col-md-2 flexx">
              <img src={capbee} alt="" className="" width={170} height={170} />
                        <img src={capbee22} alt="" className="w-100 mt-5"  />
              
            </div>
    </div>
  );
};

export default FAQ;
